import { render, staticRenderFns } from "./DispatchRoleMenuTree.vue?vue&type=template&id=267b709e&scoped=true&"
import script from "./DispatchRoleMenuTree.vue?vue&type=script&lang=js&"
export * from "./DispatchRoleMenuTree.vue?vue&type=script&lang=js&"
import style0 from "./DispatchRoleMenuTree.vue?vue&type=style&index=0&id=267b709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b709e",
  null
  
)

export default component.exports